export default {
	name: "indexView", // 定制课程
	data() {
		return {
			inputStr: "",
		};
	},
	watch: {},
	created() {},
	async mounted() {},
	onUpdated() {},
	beforeDestroy() {},
	methods: {
		gotoLecturerDetail(e) {
			this.$router.push({
				name: 'customDetail'
			});
		}
	},
};